import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export interface IDeleteOrphanedManagedKeychainParams {
  id?: string;
}

export class DeleteOrphanedManagedKeychainRequest extends Request<IDeleteOrphanedManagedKeychainParams, IResult> {
    constructor(params: IDeleteOrphanedManagedKeychainParams) {
      super('deleteOrphanedManagedKeychainsForSite', params);
    }
}